import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import store from '@/store/index.js';
import {
	fnAddDynamicMenuRoutes
} from '@/store/gatrouter.js'
Vue.use(Router);

const router = new Router({
	routes: [{
			path: '/login',
			name: 'login',
			component: () => import('@/views/Login/index'),
			hidden: true

		},
		{
			path: '/Home',
			component: Layout,
			children: [{
				path: '/Home',
				name: 'Home',
				meta: {
					label: '首页'
				},
				component: () => import('@/views/Home/index'),
			}, ]
		},
		{
			path: '/Dashboard',
			component: Layout,
			children: [{
				path: '/Dashboard',
				name: 'Dashboard',
				meta: {
					label: '数据大屏'
				},
				component: () => import('@/views/Dashboard/index'),
			}, ]
		},
		{
			path: '/Activities',
			component: Layout,
			children: [{
				path: '/Activities/management',
				name: 'management',
				meta: {
					label: '活动管理'
				},
				component: () => import('@/views/Activities/management'),
			}, {
				path: '/Activities/kinds',
				name: 'kinds',
				meta: {
					label: '优惠券种类'
				},
				component: () => import('@/views/Activities/kinds'),
			}, {
				path: '/Activities/coupon',
				name: 'coupon',
				meta: {
					label: '优惠券'
				},
				component: () => import('@/views/Activities/coupon'),
			}, ]
		},
		{
			path: '/User',
			component: Layout,
			children: [{
				path: '/User/user',
				name: 'user',
				meta: {
					label: '用户管理'
				},
				component: () => import('@/views/User/user'),
			}, {
				path: '/User/repair',
				name: 'repair',
				meta: {
					label: '报修管理'
				},
				component: () => import('@/views/User/repair'),
			}, {
				path: '/User/entry',
				name: 'entry',
				meta: {
					label: '进出记录'
				},
				component: () => import('@/views/User/entry'),
			}, ]
		},
		{
			path: '/Contract',
			component: Layout,
			children: [{
				path: '/Contract/contract',
				name: 'contract',
				meta: {
					label: '合同管理'
				},
				component: () => import('@/views/Contract/contract'),
			}, {
				path: '/Contract/renew',
				name: 'renew',
				meta: {
					label: '续租管理'
				},
				component: () => import('@/views/Contract/renew'),
			}, {
				path: '/Contract/surrender',
				name: 'surrender',
				meta: {
					label: '退租管理'
				},
				component: () => import('@/views/Contract/surrender'),
			}, ]
		},
		{
			path: '/Bills',
			component: Layout,
			children: [{
				path: '/Bills/bills',
				name: 'bills',
				meta: {
					label: '账单管理'
				},
				component: () => import('@/views/Bills/bills'),
			}, {
				path: '/Bills/orders',
				name: 'orders',
				meta: {
					label: '订单管理'
				},
				component: () => import('@/views/Bills/orders'),
			}, ]
		},
		{
			path: '/Device',
			component: Layout,
			children: [{
				path: '/Device/access/devicelist',
				name: 'access',
				meta: {
					label: '大门门禁/设备列表'
				},
				component: () => import('@/views/Device/access/devicelist'),
			}, {
				path: '/Device/access/accessuser',
				name: 'access',
				meta: {
					label: '大门门禁/人员列表'
				},
				component: () => import('@/views/Device/access/accessuser'),
			}, {
				path: '/Device/hydropower/Metermanagement',
				name: 'hydropower',
				meta: {
					label: '电表管理'
				},
				component: () => import('@/views/Device/hydropower/Metermanagement'),
			}, {
				path: '/Device/hydropower/Watermetermanagement',
				name: 'hydropower',
				meta: {
					label: '水表管理'
				},
				component: () => import('@/views/Device/hydropower/Watermetermanagement'),
			}, ]
		},
		{
			path: '/Listings',
			component: Layout,
			children: [{
				path: '/Listings/room',
				name: 'room',
				meta: {
					label: '房间管理'
				},
				component: () => import('@/views/Listings/room'),
			}, {
				path: '/Listings/password',
				name: 'password',
				meta: {
					label: '密码修改记录'
				},
				component: () => import('@/views/Listings/password'),
			}, ]
		},
		{
			path: '/RoomStatus',
			component: Layout,
			children: [{
				path: '/RoomStatus',
				name: 'RoomStatus',
				meta: {
					label: '房态管理'
				},
				component: () => import('@/views/RoomStatus/index'),
			}]
		},
		{
			path: '/System',
			component: Layout,
			children: [{
					path: '/System/parameters',
					name: 'parameters',
					meta: {
						label: '系统参数'
					},
					component: () => import('@/views/System/parameters'),
				}, {
					path: '/System/terms',
					name: 'terms',
					meta: {
						label: '条款'
					},
					component: () => import('@/views/System/terms'),
				}, {
					path: '/System/carousel',
					name: 'carousel',
					meta: {
						label: '小程序轮播图'
					},
					component: () => import('@/views/System/carousel'),
				}, {
					path: '/System/administrator',
					name: 'administrator',
					meta: {
						label: '管理员账号管理'
					},
					component: () => import('@/views/System/administrator'),
				}, {
					path: '/System/operation_log',
					name: 'operation_log',
					meta: {
						label: '操作日志'
					},
					component: () => import('@/views/System/operation_log'),
				},
				{
					path: '/System/loglist',
					name: 'loglist',
					meta: {
						label: '系统日记'
					},
					component: () => import('@/views/System/loglist'),
				},
			]
		},
		{
			path: "/",
			redirect: '/login',
			component: () => import('@/views/Login/index'),
		},
		{
			path: '/Lock',
			component: Layout,
			children: [{
				path: '/Lock',
				name: 'Lock',
				meta: {
					label: '门锁管理'
				},
				component: () => import('@/views/Lock')
			}]
		},
		{
			path: '/Intelligent_devices',
			component: Layout,
			children: [{
				path: '/Intelligent_devices/water_meter',
				name: 'water_meter',
				meta: {
					label: '智能水表'
				},
				component: () => import('@/views/Intelligent_devices/water_meter'),
			}, {
				path: '/Intelligent_devices/electricity_meter',
				name: 'electricity_meter',
				meta: {
					label: '智能电表'
				},
				component: () => import('@/views/Intelligent_devices/electricity_meter'),
			}]
		}, {
			path: '/Web/success',
			name: 'success',
			component: () => import('@/views/Web/success'),
			hidden: true

		}, {
			path: '/Web/error',
			name: 'error',
			component: () => import('@/views/Web/error'),
			hidden: true

		},
	]
})

router.beforeEach((to, from, next) => {
	// 没token
	const width = window.innerWidth;
	let minw = width <= 1030;
	sessionStorage.setItem('minw', minw)
	if (sessionStorage.getItem('token') == null) {
		// 没token但跳转首页
		// if (to.path != '/login') {
		// 	next({
		// 		path: '/login'
		// 	})
		// } else {
		//没token但跳转登录页
		next()
		// }
	} else {
		//有token且有路由列表
		if (localStorage.getItem('routes') != null) {
			next()
		} else {
			//有token但没路由列表
			console.log('没路由');
			next()
		}
	}
})

export default router